module.exports = __webpack_public_path__ + "static/1-a220405e7fe80d65a4547fb5b9d0ff43.png";